import {computed, override, makeObservable} from 'mobx';
import {Collection} from '../../Common/stores/Collection';
import {PackagesField} from './PackagesField';

export class PackagesCollection extends Collection {
    constructor(collection) {
        super(collection);

        makeObservable(this);
    }

    insertFields(parentField, children) {
        this.fields.clear();
        children.forEach(f => {
            const newField = new PackagesField(f, parentField);
            newField.setCollection(f);
            this.fields.push(newField);
        });
    }

    @override
    setExpanded(expanded) {
        if (expanded) {
            // run on sibling fields' collections and collapse them
            this.parentCollection &&
                this.parentCollection.fields.forEach(f => {
                    if (f.collection && f.collection !== this && f.collection.isExpanded) {
                        f.collection.setExpanded(false);
                    }
                });
            this.isExpanded = true;
        } else {
            this.isExpanded = false;
        }
    }

    @computed
    get hasExpendedTab() {
        return this.isExpanded || (this.parentCollection && this.parentCollection.isExpanded);
    }
}
